import React, { useState } from 'react';
import SidebarAdmin from './SidebarAdmin';
import { Container, Button, Table, Badge, Form, InputGroup, Dropdown } from 'react-bootstrap';
import { PAYS_EUROPE } from '../../config/europe';
import { PAYS_EUROPE_EST } from '../../config/europeEst';
import { ETATS_USA } from '../../config/etats';
import { PAYS_AMERIQUE_SUD } from '../../config/amerique';
import { PAYS_AFRIQUE } from '../../config/afrique';
import { PAYS_ASIE } from '../../config/asie';
import { PAYS_OCEANIE } from '../../config/oceanie';
import { LOCUTIONS_LATINES } from '../../config/expressionsLatines';
import { LOCUTIONS_GRECQUES } from '../../config/expressionsGrecques';
import { CONCEPTS_PHILOSOPHIQUES } from '../../config/conceptsPhilo';

const Culture = () => {
  const [activeTab, setActiveTab] = useState('europe');
  const [searchQuery, setSearchQuery] = useState('');

  const flagStyle = {
    fontFamily: '"Twemoji Country Flags", "Segoe UI Emoji", "Apple Color Emoji", sans-serif',
    fontSize: '1.8rem',
    lineHeight: '1'
  };

  // 🔍 FONCTION UNIVERSELLE DE FILTRAGE
  const filtrerDonnees = (liste) => {
    if (!searchQuery.trim()) return liste;

    const query = searchQuery.toLowerCase().trim();

    return liste.filter(item => {
      // Gestion des structures géographiques (nom, capitale, code)
      const nom = item.nom ? item.nom.toLowerCase() : '';
      const capitale = item.capitale ? item.capitale.toLowerCase() : '';
      const code = item.code ? item.code.toLowerCase() : '';

      // Gestion de la structure des locutions latines (locution, traduction, auteur)
      const locutionsLatines = item.locutionsLatines ? item.locutionsLatines.toLowerCase() : '';
      const traduction = item.traduction ? item.traduction.toLowerCase() : '';
      const auteur = item.auteur ? item.auteur.toLowerCase() : '';

      // Gestion de la structure des locutions grecques (expression, signification, origine)
      const locutionsGrecques = item.locutionsGrecques ? item.locutionsGrecques.toLowerCase() : '';
      const signification = item.signification ? item.signification.toLowerCase() : '';
      const origine = item.origine ? item.origine.toLowerCase() : '';

      // Gestion de la structure des locutions concepts philosophiques (expression, explication, créateur)
      const expression = item.expression ? item.expression.toLowerCase() : '';
      const explication = item.explication ? item.explication.toLowerCase() : '';
      const créateur = item.créateur ? item.créateur.toLowerCase() : '';

      return (
        nom.includes(query) ||
        capitale.includes(query) ||
        code.includes(query) ||
        locutionsLatines.includes(query) ||
        traduction.includes(query) ||
        auteur.includes(query) ||
        locutionsGrecques.includes(query) ||
        signification.includes(query) ||
        origine.includes(query) ||
        expression.includes(query) ||
        explication.includes(query) ||
        créateur.includes(query)
      );
    });
  };

  // Application des filtres sur chaque liste d'origine
  const europeFiltre = filtrerDonnees(PAYS_EUROPE);
  const europeEstFiltre = filtrerDonnees(PAYS_EUROPE_EST);
  const usaFiltre = filtrerDonnees([...ETATS_USA].sort((a, b) => a.nom.localeCompare(b.nom)), true);
  const ameriqueFiltre = filtrerDonnees(PAYS_AMERIQUE_SUD);
  const afriqueFiltre = filtrerDonnees(PAYS_AFRIQUE);
  const asieFiltre = filtrerDonnees(PAYS_ASIE);
  const oceanieFiltre = filtrerDonnees(PAYS_OCEANIE);
  const locutionsLatinesFiltre = filtrerDonnees(LOCUTIONS_LATINES);
  const locutionsGrecquesFiltre = filtrerDonnees(LOCUTIONS_GRECQUES);
  const expressionPhilosophiquesFiltre = filtrerDonnees(CONCEPTS_PHILOSOPHIQUES);

  // Helper pour afficher dynamiquement le nom de la région sélectionnée dans le Dropdown
  const getDropdownLabel = () => {
    switch (activeTab) {
      case 'europeEst': return ` Europe de l'Est (${europeEstFiltre.length})`;
      case 'usa': return `🌎 États USA (${usaFiltre.length})`;
      case 'amerique': return `🌎 Amérique du Sud (${ameriqueFiltre.length})`;
      case 'afrique': return `🌍 Afrique (${afriqueFiltre.length})`;
      case 'asie': return `🌏 Asie (${asieFiltre.length})`;
      case 'oceanie': return `🏝️ Océanie (${oceanieFiltre.length})`;
      default: return '🗺️ Autres Pays';
    }
  };

  // Vérifie si l'onglet actif fait partie du Dropdown pour appliquer le style "actif"
  const isDropdownActive = ['europeEst', 'usa', 'amerique', 'afrique', 'asie', 'oceanie'].includes(activeTab);

  return (
    <Container fluid className="py-3 min-vh-100 text-light">
      <div className="d-flex flex-column flex-md-row">
        <SidebarAdmin />

        <div className="admin-main-wrapper w-100" style={{ marginBottom: '80px' }}>
          <Container className="py-2 bg-profil min-vh-100">

            {/* 👑 EN-TÊTE DE PAGE */}
            <div className="d-flex flex-column align-items-center mb-0 pb-3">
              <h2 className="text-warning fw-semibold text-center mb-0 m-md-0" style={{ letterSpacing: '1px' }}>
                <span>🥇</span> Espace Culture
              </h2>
              <div style={{ width: '100px' }} className="d-none d-md-block"></div>
            </div>


            {/* 🔎 BARRE DE RECHERCHE INSTANTANÉE */}
            <div className="mx-auto mb-4" style={{ maxWidth: '500px' }}>
              <InputGroup className="border border-secondary rounded-3 overflow-hidden shadow-sm">
                <InputGroup.Text className="bg-dark text-warning border-0">
                  <i className="material-icons" style={{ fontSize: '20px' }}>search</i>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Rechercher un pays ou une capitale..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="bg-dark text-white border-0 py-2"
                  style={{ boxShadow: 'none' }}
                />
                {searchQuery && (
                  <Button
                    variant="light"
                    className="text-dark border-0 px-3 hover-text-warning"
                    onClick={() => setSearchQuery('')}
                  >
                    <span>✕</span>
                  </Button>
                )}
              </InputGroup>
            </div>

            {/* 🎯 BARRE D'ONGLETS */}
            <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap select-none geo-filtre mx-auto" style={{ maxWidth: '900px' }}>

              {/* Bouton Fixe : Europe */}
              <Button
                variant={activeTab === 'europe' ? 'info' : 'outline-info'}
                className="fw-semibold px-3 py-2 text-dark-if-active"
                onClick={() => setActiveTab('europe')}
                style={{ color: activeTab === 'europe' ? '#212529' : '' }}
              >
                <span>🌎</span> Europe ({europeFiltre.length})
              </Button>

              {/* Le Menu Déroulant (Dropdown) pour regrouper le reste du monde */}
              <Dropdown onSelect={(k) => setActiveTab(k)}>
                <Dropdown.Toggle
                  variant={isDropdownActive ? 'dark' : 'outline-dark'}
                  className="fw-semibold px-3 py-2 fs-6 w-100"
                >
                  {getDropdownLabel()}
                </Dropdown.Toggle>

                <Dropdown.Menu className="bg-dark border-secondary dropdown-menu-dark">
                  <Dropdown.Item eventKey="europeEst" active={activeTab === 'europeEst'}>
                    <span>🌏</span> Europe de l'Est ({europeEstFiltre.length})
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="asie" active={activeTab === 'asie'}>
                    <span>🌏</span> Asie ({asieFiltre.length})
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="afrique" active={activeTab === 'afrique'}>
                    <span>🌍</span> Afrique ({afriqueFiltre.length})
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="amerique" active={activeTab === 'amerique'}>
                    🌎 Amérique du Sud ({ameriqueFiltre.length})
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="usa" active={activeTab === 'usa'}>
                    <span>🌏</span> États USA ({usaFiltre.length})
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="oceanie" active={activeTab === 'oceanie'}>
                    <span>🏝️</span> Océanie ({oceanieFiltre.length})
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* Bouton Fixe : Locutions Latines */}
              <Button
                variant={activeTab === 'locutionsLatines' ? 'secondary' : 'outline-secondary'}
                className="fw-semibold px-3 py-2 text-white"
                onClick={() => setActiveTab('locutionsLatines')}
              >
                <span>📜</span> Latine ({locutionsLatinesFiltre.length})
              </Button>

              {/* Bouton Fixe : Locutions Grecques */}
              <Button
                variant={activeTab === 'locutionsGrecques' ? 'danger' : 'outline-danger'}
                className="fw-semibold px-3 py-2 text-white"
                onClick={() => setActiveTab('locutionsGrecques')}
              >
                <span>🏛️</span> Grecque ({locutionsGrecquesFiltre.length})
              </Button>

              {/* Bouton Fixe : Expressions Philosophiques */}
              <Button
                variant={activeTab === 'expression' ? 'success' : 'outline-success'}
                className="fw-semibold px-3 py-2 text-white"
                onClick={() => setActiveTab('expression')}
              >
                <span>🦉</span> Philosophie ({expressionPhilosophiquesFiltre.length})
              </Button>
            </div>


            {/* 📦 ZONE DE CONTENU UNIQUE DYNAMIQUE */}
            <div className="card bg-dark border-secondary shadow-lg rounded-3 p-3 p-sm-4 mx-auto" style={{ maxWidth: '1050px' }}>

              {/* --- 🇪🇺 ONGLET EUROPE --- */}
              {activeTab === 'europe' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-info fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-compass"></i> Pays d'Europe
                    </h4>
                    <Badge bg="info" className="text-dark fw-semibold p-1 fs-6">Trouvés : {europeFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Drapeau</th>
                          <th style={{ width: '30%' }}>Pays</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {europeFiltre.map((pays) => (
                          <tr key={pays.code}>
                            <td><span style={flagStyle} title={`Code : ${pays.code}`}>{pays.drapeau}</span></td>
                            <td className="fw-semibold text-white-50">{pays.nom}</td>
                            <td className="text-warning fw-semibold">{pays.capitale}</td>
                          </tr>
                        ))}
                        {europeFiltre.length === 0 && (
                          <tr><td colSpan="3" className="text-center text-muted py-4">Aucun pays ne correspond à votre recherche.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- 🇪🇺 ONGLET EUROPE DE L'EST --- */}
              {activeTab === 'europeEst' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-info fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-compass-fill"></i> Pays d'Europe de l'Est
                    </h4>
                    <Badge bg="info" className="text-dark fw-semibold p-1 fs-6">Trouvés : {europeEstFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Drapeau</th>
                          <th style={{ width: '30%' }}>Pays</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {europeEstFiltre.map((pays) => (
                          <tr key={pays.code}>
                            <td><span style={flagStyle} title={`Code : ${pays.code}`}>{pays.drapeau}</span></td>
                            <td className="fw-semibold text-white-50">{pays.nom}</td>
                            <td className="text-warning fw-semibold">{pays.capitale}</td>
                          </tr>
                        ))}
                        {europeEstFiltre.length === 0 && (
                          <tr><td colSpan="3" className="text-center text-muted py-4">Aucun pays ne correspond à votre recherche.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- 🇺🇸 ONGLET ÉTATS USA --- */}
              {activeTab === 'usa' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-success fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-globe"></i> États des USA
                    </h4>
                    <Badge bg="success" className="text-white fw-semibold p-1 fs-6">Trouvés : {usaFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Code</th>
                          <th style={{ width: '30%' }}>État</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usaFiltre.map((etat) => (
                          <tr key={etat.code}>
                            <td><Badge bg="outline-success" className="border border-success text-success fw-semibold px-3 py-2 fs-6">{etat.code}</Badge></td>
                            <td className="fw-semibold text-white-50">{etat.nom}</td>
                            <td className="text-warning fw-semibold">{etat.capitale}</td>
                          </tr>
                        ))}
                        {usaFiltre.length === 0 && (
                          <tr><td colSpan="3" className="text-center text-muted py-4">Aucun État ne correspond à votre recherche.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- 🌎 ONGLET AMÉRIQUE DU SUD --- */}
              {activeTab === 'amerique' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-danger fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-tree"></i> Amérique du Sud
                    </h4>
                    <Badge bg="danger" className="text-white fw-semibold p-1 fs-6">Trouvés : {ameriqueFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Drapeau</th>
                          <th style={{ width: '30%' }}>Pays</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ameriqueFiltre.map((pays) => (
                          <tr key={pays.code}>
                            <td><span style={flagStyle} title={`Code : ${pays.code}`}>{pays.drapeau}</span></td>
                            <td className="fw-semibold text-white-50">{pays.nom}</td>
                            <td className="text-warning fw-semibold">{pays.capitale}</td>
                          </tr>
                        ))}
                        {ameriqueFiltre.length === 0 && (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              Aucun pays ne correspond à votre recherche.
                      </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- 🌍 ONGLET AFRIQUE --- */}
              {activeTab === 'afrique' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-warning fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-sun"></i> Pays d'Afrique
                    </h4>
                    <Badge bg="warning" className="text-dark fw-semibold p-1 fs-6">Trouvés : {afriqueFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Drapeau</th>
                          <th style={{ width: '30%' }}>Pays</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {afriqueFiltre.map((pays) => (
                          <tr key={pays.code}>
                            <td><span style={flagStyle} title={`Code : ${pays.code}`}>{pays.drapeau}</span></td>
                            <td className="fw-semibold text-white-50">{pays.nom}</td>
                            <td className="text-warning fw-semibold">{pays.capitale}</td>
                          </tr>
                        ))}
                        {afriqueFiltre.length === 0 && (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              Aucun pays ne correspond à votre recherche.
                      </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- 🌏 NOUVEL ONGLET ASIE MAPPÉ DANS LE RENDER --- */}
              {activeTab === 'asie' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-success fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-globe-asia-australia"></i> Pays d'Asie
                    </h4>
                    <Badge bg="success" className="text-white fw-semibold p-1 fs-6">Trouvés : {asieFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Drapeau</th>
                          <th style={{ width: '30%' }}>Pays</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {asieFiltre.map((pays) => (
                          <tr key={pays.code}>
                            <td><span style={flagStyle} title={`Code : ${pays.code}`}>{pays.drapeau}</span></td>
                            <td className="fw-semibold text-white-50">{pays.nom}</td>
                            <td className="text-warning fw-semibold">{pays.capitale}</td>
                          </tr>
                        ))}
                        {asieFiltre.length === 0 && (
                          <tr><td colSpan="3" className="text-center text-muted py-4">Aucun pays ne correspond à votre recherche.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- 🏝️ ONGLET OCÉANIE --- */}
              {activeTab === 'oceanie' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-info fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-water"></i> Pays d'Océanie
                    </h4>
                    <Badge bg="info" className="text-dark fw-semibold p-1 fs-6">Trouvés : {oceanieFiltre.length}</Badge>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Drapeau</th>
                          <th style={{ width: '30%' }}>Pays</th>
                          <th style={{ width: '30%' }}>Capitale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {oceanieFiltre.map((pays) => (
                          <tr key={pays.code}>
                            <td><span style={flagStyle} title={`Code : ${pays.code}`}>{pays.drapeau}</span></td>
                            <td className="fw-semibold text-white-50">{pays.nom}</td>
                            <td className="text-warning fw-semibold">{pays.capitale}</td>
                          </tr>
                        ))}
                        {oceanieFiltre.length === 0 && (
                          <tr><td colSpan="3" className="text-center text-muted py-4">Aucun pays ne correspond à votre recherche.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- ONGLET LOCUTIONS LATINES --- */}
              {activeTab === 'locutionsLatines' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-info fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-journal-text"></i> Latine
                    </h4>
                    <Badge bg="info" className="text-dark fw-semibold p-1 fs-6">Trouvées : {locutionsLatinesFiltre.length}</Badge>
                  </div>

                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Locution</th>
                          <th style={{ width: '30%' }}>Traduction</th>
                          <th style={{ width: '30%' }}>Auteur</th>
                        </tr>
                      </thead>
                      <tbody>
                        {locutionsLatinesFiltre.map((item) => (
                          <tr key={item.id}>
                            <td className="fw-semibold text-white-50* font-italic">« {item.locutionsLatines} »</td>
                            <td className="text-danger">{item.traduction}</td>
                            <td className="text-warning fw-semibold">{item.auteur}</td>
                          </tr>
                        ))}
                        {locutionsLatinesFiltre.length === 0 && (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              Aucune locution ne correspond à votre recherche.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- ONGLET LOCUTIONS GRECQUES --- */}
              {activeTab === 'locutionsGrecques' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-info fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-journal-text"></i> Grecque
                    </h4>
                    <Badge bg="info" className="text-dark fw-semibold p-1 fs-6">Trouvées : {locutionsGrecquesFiltre.length}</Badge>
                  </div>

                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Expression</th>
                          <th style={{ width: '30%' }}>Signification</th>
                          <th style={{ width: '30%' }}>Origine</th>
                        </tr>
                      </thead>
                      <tbody>
                        {locutionsGrecquesFiltre.map((item) => (
                          <tr key={item.id}>
                            <td className="fw-semibold text-white-50* font-italic">« {item.locutionsGrecques} »</td>
                            <td className="text-danger">{item.signification}</td>
                            <td className="text-warning fw-semibold">{item.origine}</td>
                          </tr>
                        ))}
                        {locutionsGrecquesFiltre.length === 0 && (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              Aucune locution ne correspond à votre recherche.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}

              {/* --- ONGLET CONCEPTS PHILOSOPHIQUES --- */}
              {activeTab === 'expression' && (
                <React.Fragment>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title fs-5 mb-0 text-info fw-semibold d-flex align-items-center gap-2">
                      <i className="bi bi-journal-text"></i> Philosophie
                    </h4>
                    <Badge bg="info" className="text-dark fw-semibold p-1 fs-6">Trouvées : {expressionPhilosophiquesFiltre.length}</Badge>
                  </div>

                  <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table variant="dark" hover align="middle" className="mb-0">
                      <thead className="table-dark sticky-top shadow-sm" style={{ top: 0, zIndex: 1 }}>
                        <tr>
                          <th style={{ width: '40%' }}>Expression</th>
                          <th style={{ width: '30%' }}>Signification</th>
                          <th style={{ width: '30%' }}>Origine</th>
                        </tr>
                      </thead>
                      <tbody>
                        {expressionPhilosophiquesFiltre.map((item) => (
                          <tr key={item.id}>
                            <td className="fw-semibold text-white-50* font-italic">« {item.expression} »</td>
                            <td className="text-danger">{item.explication}</td>
                            <td className="text-warning fw-semibold">{item.créateur}</td>
                          </tr>
                        ))}
                        {expressionPhilosophiquesFiltre.length === 0 && (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              Aucune expression ne correspond à votre recherche.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </React.Fragment>
              )}
            </div>
          </Container>
        </div>
      </div>
    </Container>
  );
};

export default Culture;
